var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg65F6D2D51Aa78130Db14A717467062E5Bba38E4D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 840 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    y1: 0.5,
    x2: 840,
    y2: 0.5,
    stroke: "var(--stroke-0, #D5DBEA)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg65F6D2D51Aa78130Db14A717467062E5Bba38E4D);
export default __webpack_public_path__ + "static/media/65f6d2d51aa78130db14a717467062e5bba38e4d.a589973aa1ef484dd0c2cde48c245b59.svg";
export { ForwardRef as ReactComponent };